import { Button } from '@chakra-ui/react';
import React, { FormEvent, memo, useState } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { FaSearch } from 'react-icons/fa';
import Select from 'react-select';

export type SearchValues = {
    sid?: string;
    citizenId?: string;
    from?: Date | null;
    to?: Date | null;
};

type SelectOption = { value: string; label: string };

type Props = {
    onSubmitSearch: (values: SearchValues) => void;
    companyOptions: SelectOption[];
    isCompanyLocked: boolean;
    selectedSid: string;
    onSidChange: (sid: string) => void;
};

function AuthenticationHistorySearchBar(props: Props) {
    const { onSubmitSearch, companyOptions, isCompanyLocked, selectedSid, onSidChange } = props;

    const [citizenId, setCitizenId] = useState<string>('');
    const [from, setFrom] = useState<Date | null>(null);
    const [to, setTo] = useState<Date | null>(null);

    const selectMenuStyle = { menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) };

    const handleSubmitSearch = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        onSubmitSearch({ sid: selectedSid || undefined, citizenId: citizenId?.trim(), from, to });
    };

    return (
        <form onSubmit={handleSubmitSearch}>
            <Card.Body
                className="mat-box shadow"
                style={{ overflow: 'none', borderColor: '#e5e6e9 #dfe0e4 #d0d1d5', borderStyle: 'solid', borderWidth: '1px' }}
            >
                <Row>
                    <Col xs={3}>
                        <Form.Group className="mb-3">
                            <Form.Label>บริษัท :</Form.Label>
                            <Select
                                menuPortalTarget={document.body}
                                styles={selectMenuStyle}
                                placeholder="เลือก บริษัท"
                                options={companyOptions}
                                value={companyOptions.find(c => c.value === selectedSid) ?? null}
                                onChange={opt => onSidChange(opt?.value ?? '')}
                                isClearable={!isCompanyLocked}
                                isDisabled={isCompanyLocked}
                            />
                        </Form.Group>
                    </Col>
                    <Col xs={3}>
                        <Form.Group className="mb-3">
                            <Form.Label>User :</Form.Label>
                            <Form.Control
                                value={citizenId}
                                onChange={e => setCitizenId(e.target.value)}
                                placeholder="ค้นหา User"
                            />
                        </Form.Group>
                    </Col>
                    <Col xs={3}>
                        <Form.Group className="mb-3">
                            <Form.Label>From :</Form.Label>
                            <DatePicker
                                wrapperClassName="d-block"
                                selectsStart
                                selected={from}
                                startDate={from}
                                endDate={to}
                                onChange={setFrom}
                                showTimeSelect
                                timeFormat="HH:mm"
                                timeIntervals={5}
                                timeCaption="time"
                                dateFormat="dd/MM/yyyy HH:mm"
                                customInput={<Form.Control />}
                                isClearable
                            />
                        </Form.Group>
                    </Col>
                    <Col xs={3}>
                        <Form.Group className="mb-3">
                            <Form.Label>To :</Form.Label>
                            <DatePicker
                                wrapperClassName="d-block"
                                selectsEnd
                                selected={to}
                                startDate={from}
                                endDate={to}
                                minDate={from}
                                onChange={setTo}
                                showTimeSelect
                                timeFormat="HH:mm"
                                timeIntervals={5}
                                timeCaption="time"
                                dateFormat="dd/MM/yyyy HH:mm"
                                customInput={<Form.Control />}
                                isClearable
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Button
                            type="submit"
                            colorScheme="green"
                            leftIcon={<FaSearch />}
                            size="sm"
                            style={{ float: 'right' }}
                        >
                            ค้นหา
                        </Button>
                    </Col>
                </Row>
            </Card.Body>
        </form>
    );
}

export default memo(AuthenticationHistorySearchBar);
